export default __webpack_public_path__ + "static/media/APM.1f04a8b2.svg";